// extracted by mini-css-extract-plugin
export default {"root":"telegram-button_root__O76L5","hover":"telegram-button_hover__EG3YL","text":"telegram-button_text__x0Rko","icon":"telegram-button_icon__6p3qk"};